import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper';

import { IVacancySection, IVacancySectionListItem, VacancySectionResponseType } from '@/entity/Settings/vacancy_section.types';
import { SiteVacancySectionRequestType } from '@/form/Settings/site/vacancy_section.types';

@Module({
    namespaced: true,
    name: 'vacancySection',
    store,
    dynamic: true
})

class VacancySectionModule extends VuexModule implements IStoreReady  {
    vacancySection: IVacancySection | null = null
    vacancySectionItem: IVacancySectionListItem | null = null
    vacancySectionLoaded = false
    vacancySectionItemLoaded = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ vacancySection: IVacancySection; vacancySectionLoaded: boolean }> {
        let vacancySectionLoaded = false;
        const vacancySection = await store.$repository.vacancy_section.fetchAll(prepareFormData(data));
        if(vacancySection){
            vacancySectionLoaded = true;
        }
        return { vacancySection, vacancySectionLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ vacancySectionItem: IVacancySectionListItem  ; vacancySectionItemLoaded: boolean }> {
        let vacancySectionItemLoaded = false;
        const vacancySectionItem = await store.$repository.vacancy_section.fetchData(data);
        if (vacancySectionItem) {
            vacancySectionItemLoaded = true;
        }
        return { vacancySectionItem, vacancySectionItemLoaded};
    }

    @Action({rawError: true})
    async create(data: SiteVacancySectionRequestType): Promise<ResponseDataType> {
        console.log(data);
        return await store.$repository.vacancy_section.create(data);
    }

    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
    
}

export const VacancySectionStore = getModule(VacancySectionModule);